"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BonusTournamentTicketsEditor_1 = require("./BonusTournamentTicketsEditor");
var BonusTournamentTicketsList_1 = require("./BonusTournamentTicketsList");
var BonusTournamentTickets = /** @class */ (function (_super) {
    __extends(BonusTournamentTickets, _super);
    function BonusTournamentTickets(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentTickets.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ availCurrency: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            availCurrency: []
        }, function () {
            _this.props.listAppCurrency.LoadData();
        });
        this.props.state.setExtBreadCrumbPath(["Турниры", "Суммы турниров"]);
    };
    BonusTournamentTickets.prototype.componentWillUnmount = function () {
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
    };
    BonusTournamentTickets.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BonusTournamentTickets.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    BonusTournamentTickets.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", record: item });
    };
    BonusTournamentTickets.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    BonusTournamentTickets.prototype.getBrandCountriesRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BonusTournamentTicketsEditor_1.default, { state: this.props.state, data: this.props.dataAmounts, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availCurrency: this.state.availCurrency, record: null }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BonusTournamentTicketsEditor_1.default, { state: this.props.state, data: this.props.dataAmounts, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availCurrency: this.state.availCurrency, record: this.state.record }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BonusTournamentTicketsList_1.default, { state: this.props.state, data: this.props.dataAmounts, rootRecord: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this), onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this) }));
        }
    };
    BonusTournamentTickets.prototype.render = function () {
        return (React.createElement("div", null, this.getBrandCountriesRenderObject()));
    };
    return BonusTournamentTickets;
}(React.Component));
exports.default = BonusTournamentTickets;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/tickets/BonusTournamentTickets.tsx
// module id = 2508
// module chunks = 0